import { render, staticRenderFns } from "./WorkspacePage.vue?vue&type=template&id=38f4c6d0&scoped=true&"
import script from "./WorkspacePage.vue?vue&type=script&lang=js&"
export * from "./WorkspacePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f4c6d0",
  null
  
)

export default component.exports